// import React from "react";
// import "./HomeSection1.css";

// const HomeSection1 = () => {

//   const data = [
//     { title: "Women Ethnic Wear", offer: "50-80% OFF", img: "./img/ethnic.jpg" },
//     { title: "Women Western Wear", offer: "30-80% OFF", img: "./img/casual_wear.jpg" },
//     { title: "Lingerie", offer: "30-70% OFF", img: "https://images.unsplash.com/photo-1585487000160-6ebcfceb0d03" },
//     { title: "Loungewear", offer: "40-80% OFF", img: "https://images.unsplash.com/photo-1600185365483-26d7a4cc7519" },
//     { title: "Beauty & Care", offer: "40-80% OFF", img: "https://images.unsplash.com/photo-1522335789203-aabd1fc54bc9" },

//     { title: "Casual Wear", offer: "40-80% OFF", img: "https://images.unsplash.com/photo-1521572163474-6864f9cf17ab" },
//     { title: "Office Wear", offer: "30-70% OFF", img: "https://images.unsplash.com/photo-1552374196-c4e7ffc6e126" },
//     { title: "Women's Activewear", offer: "30-70% OFF", img: "https://images.unsplash.com/photo-1518310383802-640c2de311b2" },
//     { title: "Innerwear", offer: "50-80% OFF", img: "https://images.unsplash.com/photo-1596464716127-f2a82984de30" },

//     { title: "Men's Activewear", offer: "40-80% OFF", img: "https://images.unsplash.com/photo-1599058917765-a780eda07a3e" },
//     { title: "Streetwear", offer: "40-80% OFF", img: "https://images.unsplash.com/photo-1520975916090-3105956dac38" },

//     { title: "Home Setup", offer: "50-80% OFF", img: "https://images.unsplash.com/photo-1602810318383-e386cc2a3ccf" }
//   ];

//   return (
//     <div className="shop-section">
//       <h2 className="shop-title">Trending Categories</h2>

//       <div className="shop-grid">
//         {data.map((item, index) => (
//           <div className="shop-card" key={index}>
//             <img src={item.img} alt={item.title} />
//             <div className="card-content">
//               <p>{item.title}</p>
//               <h3>{item.offer}</h3>
//               <span>Shop Now →</span>
//             </div>
//           </div>
//         ))}
//       </div>
//     </div>
//   );
// };

// export default HomeSection1;




import React, { useEffect, useRef, useState } from "react";
import "./HomeSection1.css";
import axios from "axios";
import { toast } from "react-toastify";
import { Link } from "react-router-dom";

const HomeSection1 = () =>  {
  const [data, setData] =  useState([]);
  const titleRef = useRef(null);


  useEffect(() => {
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("animate-in");
        }
      });
    },
    { threshold: 0.1 }
  );

  if (titleRef.current) {
    observer.observe(titleRef.current);
  }

  return () => observer.disconnect();
}, []);

  useEffect(() => {
  const fetchData = async () => {
    try {
      const response = await axios.post(
        "https://cyberathon.com/multivendor/index.php/Api/Master_controller/list_main_subcategory"
      );

      const filterdData = response.data.row.filter(item => item.category_id === "2");

      setData(filterdData || []);

      console.log("API Response Sub Category:", response.data);

      if (response.data.success === "1") {
        toast.success(response.data.message || "Data fetched successfully!");
      } else {
        toast.error(response.data.error || "Failed to fetch data.");
      }
    } catch (error) {
      console.error(error);
      toast.error("Failed to fetch data.");
    }
  };

  fetchData();
}, []);

  return (
    <div className="shop-section">
      <h2 className="shop-title" ref={titleRef}>Shop by Category</h2>

      <div className="shop-grid">
        {data.map((item, index) => (
  <div
    className="shop-card"
    key={index}
    // ref={(el) => (cardRefs.current[index] = el)}
    // style={{ "--delay": `${index * 60}ms` }}
  >
    <img
      src={`https://cyberathon.com/multivendor/${item.image}`}
      alt={item.subcategory_name}
      loading="lazy"
    />

    <div className="card-overlay">
      <div className="card-content">
        <p>{item.subcategory_name}</p>
        <p>50% OFF</p>
        <Link
  to={`/products?category=${item.category_id}&subcategory=${item.subcategory_id}`}
  className="shop-now"
>
         <button className="Addto-cart">
          Shop Now →
        </button>
        </Link>
      </div>
    </div>
  </div>
))}
      </div>
    </div>
  );
};

export default HomeSection1;